import { useState } from 'react';
import { DiamondIcon } from '@THC/components/Icons/Diamond';

import { TickIcon } from '@motorway/mw-highway-code';

import ExpandableListItem from 'Components/shared/ExpandableListItem/ExpandableListItem';
import useUser from 'Utilities/hooks/useUser';

import styles from './MobilizeSection.module.scss';

const MOBILIZE_DEALER_BENEFITS = [
	'£235 Motorway flat fee',
	'Motorway Protect included, free (worth £44.99)',
	'£50 off your Motorway Move collection fee',
	'Fast collection: date pre-booked, no seller checks required.',
];

const BASE_BENEFITS = [
	'Motorway Protect included, free (worth £44.99)',
	'£50 off your Motorway Move collection fee',
	'Fast collection: date pre-booked, no seller checks required.',
];

const FOOTER_TEXT = 'Motorway Move collection is required on these vehicles to ensure a BVRLA inspection';

export const MobilizeSection: React.FC = () => {
	const user = useUser();
	const isMobilizeDealer = user.partners?.some((p: string) => p.toLowerCase() === 'mobilize') ?? false;
	const benefits = isMobilizeDealer ? MOBILIZE_DEALER_BENEFITS : BASE_BENEFITS;
	const [isExpanded, setIsExpanded] = useState(true);

	return (
		<div className={styles.container}>
			<p className={styles.description}>
				Ex-lease vehicles you won&apos;t find anywhere else. Single owner, structured lease and regularly serviced.
			</p>
			<div className={styles.expandableWrapper}>
				<ExpandableListItem
					isSmall
					classNames={{
						container: styles.expandable,
						content: styles.expandableContent,
						header: styles.expandableHeader,
						title: styles.expandableTitle,
					}}
					id="mobilize-benefits"
					isExpanded={isExpanded}
					onClick={() => setIsExpanded(!isExpanded)}
					title={
						<span className={styles.titleContent}>
							<DiamondIcon size="xsmall" />
							What makes these vehicles special?
						</span>
					}
				>
					<ul className={styles.benefitsList}>
						{benefits.map((benefit) => (
							<li key={benefit} className={styles.benefitItem}>
								<span className={styles.tickIcon}>
									<TickIcon size="xsmall" />
								</span>
								<span>{benefit}</span>
							</li>
						))}
					</ul>
					<p className={styles.footer}>{FOOTER_TEXT}</p>
				</ExpandableListItem>
			</div>
		</div>
	);
};
